import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams, ViewController} from 'ionic-angular';
import {TranslateService} from "@ngx-translate/core";
import {TagInformationService} from "../../providers/tag.information.service";
import {
  CONFIGURATION_ERROR,
  INVALID_FORMAT,
  NOT_FOUND,
  SERVER_ERROR,
  TAG_INFORMATION_SOURCE_POPOVER,
  UNKNOWN_ERROR
} from "../../app/app.constants";

/**
 * Generated class for the PopogerDetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-popover-details',
  templateUrl: 'popover-details.html',
})
export class PopoverDetailsPage {

  private tag: string = '';
  public title: string = '';
  public isGeigerButtonVisible: boolean = true;
  public isFindItemButtonVisible = false;
  public isImageGoingToBeDisplayed = false;
  public isLoading: boolean;
  public isError: boolean = false;
  public errorTitle: string = '';
  public errorMessage: string = '';
  public source = TAG_INFORMATION_SOURCE_POPOVER;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public translate: TranslateService,
              public viewCtrl: ViewController,
              private tagInformationService: TagInformationService) {
    this.title = navParams.get('title');
    this.tag = navParams.get('tag');
    this.isGeigerButtonVisible = navParams.get('showGeigerButton');
    this.isImageGoingToBeDisplayed = navParams.get('isImageAviable');
    this.isFindItemButtonVisible = navParams.get('findItemOption');
  }

  ionViewDidLoad() {
    this.isLoading = true;
    this.tagInformationService.setTag(this.tag, this.source);
  }

  callbackClick() {
    this.viewCtrl.dismiss(true);
  }

  ionViewDidLeave() {
    this.tagInformationService.reset(this.source);
  }

  onFinishedLoadingDetails() {
    this.isLoading = false;
    this.isError = false;
  }

  onNoInformationFound() {
    this.isLoading = false;
    this.isError = true;
  }

  onErrorLoadingDetails(error) {
    this.isLoading = false;
    this.handleError(error);
  }

  private handleError(error) {
    this.isError = true;
    if (error.errorCode != null) {
      if (error.errorCode == NOT_FOUND) {
        this.errorTitle = 'tagInformation.noResults.title';
        this.errorMessage = 'tagInformation.noResults.message';
      } else if (error.errorCode == INVALID_FORMAT) {
        this.errorTitle = 'tagInformation.invalidFormat.title';
        this.errorMessage = 'tagInformation.invalidFormat.message';
      } else if (error.errorCode == SERVER_ERROR) {
        this.errorTitle = 'tagInformation.serverError.title';
        this.errorMessage = 'tagInformation.serverError.message';
      } else if (error.errorCode == UNKNOWN_ERROR) {
        this.errorTitle = 'tagInformation.unknownError.title';
        this.errorMessage = 'tagInformation.unknownError.message';
      } else if (error.errorCode == CONFIGURATION_ERROR) {
        this.errorTitle = 'tagInformation.configurationError.title';
        this.errorMessage = 'tagInformation.configurationError.message';
      }
    } else {
      this.errorTitle = 'noResults.title';
      this.errorMessage = 'noResults.title';
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/popover-details/popover-details.ts